import { Button } from "@mui/material";
import { Run } from "../../../services/perspective_api/__generated__/perspective_server-types";
import { useMemo } from "react";

export const StartRunButtonComponent = ({
  engineInProgress,
  runInProgress,
  onClick,
  loading,
}: {
  engineInProgress: boolean;
  runInProgress: Run | null;
  onClick: () => void;
  loading: boolean;
}) => {
  const buttonLabel = useMemo(() => {
    if (engineInProgress && runInProgress) {
      if (runInProgress?.runSettings.workflowId === "workflow_atomic_pivots") {
        return `Running ... ${runInProgress?.atStep! / runInProgress?.totalSteps! ? `${Math.round((runInProgress?.atStep! / runInProgress?.totalSteps!) * 100)}%` : ""}`;
      } else if (
        runInProgress?.runSettings.workflowId === "google_drive_sync"
      ) {
        return `Data sync ...`;
      }
    }
    return "Start run";
  }, [engineInProgress, runInProgress]);
  return (
    <Button
      variant={engineInProgress ? "outlined" : "contained"}
      onClick={onClick}
      disabled={engineInProgress || loading}
      loading={engineInProgress}
      loadingPosition="end"
      sx={{ mr: 1 }}
    >
      {buttonLabel}
    </Button>
  );
};
